import React from 'react'
import IconClose from 'client/icons/Close'
import { ButtonResetBase } from './styles'

interface Props {
  handleClick: (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => void
  visible: boolean
}

const ButtonReset = ({ handleClick, visible }: Props) => {
  const handleMouse = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    handleClick(e)
  }

  return (
    <ButtonResetBase
      onMouseDown={handleMouse}
      role="button"
      tabIndex={0}
      data-testid="search-reset-button"
      className="button-reset"
      hidden={!visible}
    >
      <IconClose />
    </ButtonResetBase>
  )
}

export default ButtonReset
